//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import colors from '@/shared/assets/scss/colorsExport.scss';
import SplitViewOverlay from '~/components/SplitViewOverlay.vue';
import FightGraph from './Lifestyle_FightGraph.vue';

export default {
  name: 'Lifestyle_Fight',
  components: {
    SplitViewOverlay,
    FightGraph,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    colors,
  }),
};
